// removed by extract-text-webpack-plugin
module.exports = {"container":"oBaYLYT-3hiFNqzWF8d8_","chatContainer":"_2IFCKGv4xZ4ZbJUc21YZHU"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ed9cf396","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"sourceMap":true}!./src/components/meetings/LiveCoach/LiveCoach.less
// module id = 6yv1
// module chunks = 1